import { forwardRef, useMemo } from "react";
import classNames from "classnames";

import "./styles.scss";

export const CRange = forwardRef(
  (
    {
      className,
      min = 0,
      max = 100,
      value,
      onChange,
      hideLabel = false,
      hideSuffix = false,
      suffix = "%",
      fillColor = "#FFB946",
      emptyColor = "#d3d8dd",
      disabled,
      ...props
    },
    ref
  ) => {
    //#region Data
    const percentRange = useMemo(
      () => ((value - min) / (max - min)) * 100 ?? 0,
      [min, max, value]
    );
    //#endregion

    //#region Event
    const onSliderChange = (e) => {
      onChange?.(Number(e.target.value));
    };

    //#endregion

    //#region Render
    return (
      <div className="c-range-wrapper flex items-center gap-3">
        <input
          ref={ref}
          value={value}
          disabled={disabled}
          onChange={onSliderChange}
          type="range"
          min={min}
          max={max}
          aria-valuenow={value}
          className={classNames("c-range relative bg-[#d3d8dd]", className)}
          style={{
            "--range-value": percentRange,
            "--range-fill-color": fillColor,
          }}
        />
        {!hideLabel && (
          <span className="font-semibold shrink-0">
            {value}
            {!hideSuffix && ` ${suffix}`}
          </span>
        )}
      </div>
    );
    //#endregion
  }
);
